import { authenticatedClient } from '../lib/client';
import { MULTI_AGENT_ENDPOINTS } from './multi_agent.utils';
import type { ApiResponse } from '../lib/types';
import type { MultiAgent, CreateMultiAgentRequest } from './multi_agent.types';

export const getMultiAgents = async (): Promise<ApiResponse<MultiAgent[]>> => {
    try {
        const response = await authenticatedClient.get(MULTI_AGENT_ENDPOINTS.GET_ALL);
        // console.log("Multi agents:", response.data);
        return { data: response.data };
    } catch (error: any) {
        return { error: error.response?.data?.message || 'Failed to fetch multi agents' };
    }
};

export const getMultiAgentById = async (multiAgentId: string): Promise<ApiResponse<MultiAgent>> => {
    try {
        const response = await authenticatedClient.get(MULTI_AGENT_ENDPOINTS.GET_BY_ID(multiAgentId));
        // console.log("Multi agent:", response.data);
        return { data: response.data };
    } catch (error: any) {
        return { error: error.response?.data?.message || 'Failed to fetch multi agent' };
    }
};

export const createMultiAgent = async (payload: CreateMultiAgentRequest): Promise<ApiResponse<MultiAgent>> => {
    try {
        const response = await authenticatedClient.post(MULTI_AGENT_ENDPOINTS.CREATE, payload);
        // console.log("Created multi agent:", response.data);
        return { data: response.data };
    } catch (error: any) {
        return { error: error.response?.data?.message || 'Failed to create multi agent' };
    }
};

export const updateMultiAgent = async (
    multiAgentId: string,
    payload: CreateMultiAgentRequest
): Promise<ApiResponse<MultiAgent>> => {
    try {
        // console.log('Updating multi agent with payload:', JSON.stringify(payload, null, 2));
        const response = await authenticatedClient.patch(MULTI_AGENT_ENDPOINTS.UPDATE(multiAgentId), payload);
        // console.log("Updated multi agent response:", response.data);
        return { data: response.data };
    } catch (error: any) {
        // console.error('Update phone number error:', error);
        // console.error('Error response:', error.response?.data);
        return { 
            error: error.response?.data?.detail || 
                  error.response?.data?.message || 
                  error.message || 
                  'Failed to update phone number' 
        };
    }
};

export const deleteMultiAgent = async (multiAgentId: string): Promise<ApiResponse<MultiAgent>> => {
    try {
        const response = await authenticatedClient.delete(MULTI_AGENT_ENDPOINTS.DELETE(multiAgentId));
        // console.log("Deleted multi agent:", response.data);
        return { data: response.data };
    } catch (error: any) {
        return { error: error.response?.data?.message || 'Failed to delete multi agent' };
    }
};
